const roundDecimal = (num, decimal = 100) => Math.round(num * decimal) / decimal;

export default roundDecimal;
